import { BaseApi } from '../core/api';
import { VerifyDTO } from '../core/models/organization';
import { Property } from '../core/models/properties';

const BRAZIL_COUNTRY_VALUES = new Set(['br', 'bra', 'brazil', 'brasil']);

export const isPropertyInBrazil = (
  property?: Partial<Pick<Property, 'country' | 'country_code' | 'regulatory_zone'>>
): boolean =>
  [property?.country_code, property?.regulatory_zone, property?.country].some(
    (value) => typeof value === 'string' && BRAZIL_COUNTRY_VALUES.has(value.toLowerCase())
  );

export const getPropertiesPermissions = async (properties: Property[]): Promise<Property[]> => {
  const operations = properties.map((property) => ({
    action: 'property:write',
    resource: property.crn,
  }));

  try {
    const { data } = await BaseApi.post<VerifyDTO>('/auth/verify', { operations });

    const allowedOperations = data.allowed_operations;

    return properties.map((property) => ({
      ...property,
      is_write_allowed: allowedOperations.some((operation) => operation.resource === property.crn),
    }));
  } catch (e) {
    console.error('Failed to verify property write permissions:', e);
    return properties.map((property) => {
      return { ...property, is_write_allowed: false };
    });
  }
};
